import { render, staticRenderFns } from "./ClienteUnificarModal.vue?vue&type=template&id=b22c91b6"
import script from "./ClienteUnificarModal.vue?vue&type=script&lang=js"
export * from "./ClienteUnificarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports